export default {
  profile: "Meu Perfil",
  professional: "Meus Dados Profissionais",
  educationInterest: "Meus Interesses",
  interests: "Meus Interesses",
  card: "Meu Cartão de Visita",
  challenge: "Meus Desafios",
}
